import React, { useEffect, useState, useRef } from 'react';
import {
    Container,
    Box,
    Avatar,
    Typography,
    Grid,
    TextField,
    Button,
    Paper,
    Divider,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
    Chip,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Snackbar,
} from '@mui/material';
import { Grid2 } from '@mui/material';
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";
import { useNavigate, useParams, useSearchParams, useLocation } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, styled } from '@mui/material/styles';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';

const PwdTextField = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    showPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                onMouseUp={handleMouseUpPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}

            {...props}
        />
    )
}

const UserInfo = () => {
    let navigate = useNavigate();
    const { state } = useLocation();	// 2번 라인
    const { userItem } = state;

    const { userData, isLogin, updateUserInfo, actions } = useBookContext();

    const [init, setInit] = useState(true);
    const [name, setName] = useState(userItem.userName);
    const [email, setEmail] = useState(userItem.userEmail);
    const [phone, setPhone] = useState(userItem.userPhone);

    const [userCourse, setUserCourse] = useState([]); //골프장

    const [newCourse, setNewCourse] = useState('');
    const [userId, setUserId] = useState('');
    const [userPw, setUserPw] = useState('');

    const textCourseNameRef = useRef(null);
    const userIdRef = useRef(null);
    const userPwRef = useRef(null);


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));



    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });

    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');

    useEffect(() => {
        console.log("userInfo userItem :"+JSON.stringify(userItem))
        getUserCourse();
        actions.extendTime(userData);
        getUserCourse();
    }, [userData]);


    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg) => {
        setMessageSnackbar(msg);
        setStateSnackBar({ ...stateSnackBar, openSnackBar: true })
    }


    const getPhoneNumber = () => {
        if (!phone ) {
            return null;
        }
        const result = phone.replace(/[^0-9.]/g, "")
            .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
            .replace(/(-{1,2})$/g, "");

        return result;
    }



    const getUserCourse = async () => {
        try {
            const reqData = {};
            reqData.userEmail = email;
            reqData.onlyMaked = 0;

            let response = await axios.post("/api/booking/GetMyCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                console.log("getUserCourse :" + JSON.stringify(courseData))
                setUserCourse(courseData);
            }
        } catch (err) {
            console.error(err);

        }
    }



    const addCourse = async () => {

        var selCourse = undefined;

        if (!newCourse || newCourse.length < 1) {
            showSnackBar('원하는 골프장을 입력하세요');
            if (textCourseNameRef.current) {
                textCourseNameRef.current.focus();
            }
            return;
        }


        if (!userId || userId.length < 1) {
            showSnackBar('골프장 아이디를 입력하세요');
            if (userIdRef.current) {
                userIdRef.current.focus();
            }
            return;
        }

        if (!userPw || userPw.length < 1) {
            showSnackBar('골프장 비밀번호를 입력하세요');
            if (userPwRef.current) {
                userPwRef.current.focus();
            }
            return;
        }

        /*
                if (selectedCourse && selectedCourse.courseName == newCourse) {
                    selCourse = selectedCourse;
                } else {
                    selCourse = findExistCourse(newCourse);
                }
        */


        try {
            const reqData = {};

            reqData.userEmail = email;
            reqData.memberId = userId;
            reqData.memberPw = userPw;

            reqData.inputCourseName = newCourse;
            reqData.needMakeNew = 1;


            let response = await axios.post("/api/booking/AddMyCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                setUserId('');
                setUserPw('');
                setNewCourse('');
                console.log("addCourse :" + JSON.stringify(courseData))
                await getUserCourse();
            } else {
                if (response.data.code === 100) {
                    showSnackBar('이미 등록된 골프장입니다');

                } else {
                    showSnackBar('골프장 등록에 실패하였습니다');
                }
            }
        } catch (err) {
            console.error(err);
            showSnackBar('골프장 등록에 실패하였습니다');

        }



    }

    const delCourse = async (course) => {


        try {
            const reqData = {};

            reqData.userEmail = email;
            reqData.myCourseNum = course.num;


            let response = await axios.post("/api/booking/DelMyCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                await getUserCourse();
            } else {
                showSnackBar('골프장 삭제에 실패하였습니다');
            }
        } catch (err) {
            console.error(err);
            showSnackBar('골프장 삭제에 실패하였습니다');

        }

    }

    const renderUserCourse = (course) => {

        console.log("renderUserCourse :" + JSON.stringify(course))

        if (!course) {
            return null;
        }

        let bgAvatarColor = 'success.main';
        let avatarSize = isMobile ? 24 : 56;
        let btnSize = isMobile ? 'small' : 'midium';
        if (course.needMakeNew == 1) {
            bgAvatarColor = 'warning.main';
        }

        return (
            <ListItem key={course.num}
                sx={{
                    marginBottom: 3,
                    padding: 0,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        // Add other flexbox properties as needed, e.g., justifyContent, alignItems
                        boxShadow: 3, // Applies an elevation level of 3
                        //                        border: '2px dashed black'
                        padding: { xs: 2, sm: 2, md: 2 },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            // Add other flexbox properties as needed, e.g., justifyContent, alignItems
                            justifyContent: "space-between"
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: isMobile ? '5px' : '16px', // Example for spacing between items
                                alignItems: "center",
                            }}
                        >
                            <Avatar sx={{ bgcolor: bgAvatarColor, width: avatarSize, height: avatarSize }} aria-label="recipe">
                                G
                            </Avatar>
                            <Typography
                                variant={isMobile ? 'subtitle1' : 'h6'}
                                sx={{
                                    display: 'flex',
                                }}                    >
                                {course.needMakeNew == 0 ? course.courseName : course.inputCourseName}
                            </Typography>

                        </Box>
                        <Stack
                            spacing={1}
                            direction="row"
                            sx={{
                                justifyContent: "flex-end",
                                alignItems: "center",
                            }}

                        >
                            {course.needMakeNew == 1 ? <Chip size={btnSize} label="신청중..." color="warning" variant="outlined" /> : null}
                            <Button size={btnSize} variant="outlined" onClick={() => delCourse(course)}>삭제</Button>
                        </Stack>
                    </Box>
                    <Stack
                        direction="column"
                        sx={{
                            marginTop: 2,
                            justifyContent: "center",
                            alignItems: "center",
                        }}

                    >
                        <Typography variant={isMobile ? 'body2' : 'subtitle1'}>아이디 : {course.memberId}, </Typography>
                        <Typography variant={isMobile ? 'body2' : 'subtitle1'}> 비밀번호 : {course.memberPw}</Typography>
                    </Stack>

                </Box>
            </ListItem>



        )
    }


    return (
        <Container maxWidth="md" sx={{ mt: 4 }}>
            <Paper elevation={3} sx={{ p: 4,  }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid xs={12} sm={6} md={4}>
                        <Typography variant="h4" gutterBottom>
                            {name ? name : ''}
                        </Typography>
                        <Typography variant="h6" color="text.secondary">
                            {email ? email : ''}
                        </Typography>
                        <Typography variant="h6" color="text.secondary" sx={{ mt: 1 }}>
                            {getPhoneNumber()}
                        </Typography>
                    </Grid>

                </Grid>

                <Divider sx={{ my: 3 }} />

                
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="원하는 골프장을 입력하세요"
                    value={newCourse}
                    inputRef={textCourseNameRef}
                    onChange={(e) => setNewCourse(e.target.value)}
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="userId"
                    label="골프장 아이디"
                    name="userId"
                    autoComplete="nickname"
                    value={userId}
                    inputRef={userIdRef} 
                    onChange={(e) => setUserId(e.target.value)}
                />
                <PwdTextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="골프장 비밀번호"
                    id="password"
                    autoComplete="current-password"
                    inputRef={userPwRef} 
                    value={userPw}
                    onChange={(e) => setUserPw(e.target.value)}
                />


                <Stack
                    spacing={1}
                    direction="row"
                    sx={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }}

                >
                    <Button variant="contained" onClick={() => addCourse()} >
                        추가
                    </Button>
                </Stack>



                <List sx={{ width: '100%', bgcolor: 'background.paper', marginTop: 5, }}>
                    {userCourse.map((course) => renderUserCourse(course))}
                </List>


            </Paper>
            <Snackbar
                anchorOrigin={{ vertical: verticalSnackBar, horizontal: horizontalSnackBar }}
                open={openSnackBar}
                onClose={handleSnackBarClose}
                message={messageSnackBar}
                key={verticalSnackBar + horizontalSnackBar}
                autoHideDuration={5000}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleSnackBarClose}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            />
        </Container>
    );
}
export default UserInfo;